import { getCurrentUserId } from '../../infra/firebase/init';
import { ChatRowData, NewMessageChatRow } from '../../modules/home/v1/components/chat-list-section/chat-row/typings';
import { getCountFromStatus } from '../../modules/home/v1/states/chat';
import { MessageTypes } from '../../modules/home/v1/typings/message-types';

const chatRowDataHelper = (newData: NewMessageChatRow, oldData?: ChatRowData): ChatRowData => {
  const currentUserId = getCurrentUserId();
  const modifiedData = {
    ...oldData,
    ...newData.chat,
    id: newData.chatId,
    unreadCount: newData.chat.unreadCount,
    assignedUserId: newData.chat.assignedUserId,
    assignedUserName: newData.chat.assignedUserName,
    integrationId: newData.integrationId,
    integrationWabaNumber: newData.integrationWabaNumber,
    integrationWabaPhoneName: newData.integrationWabaPhoneName,
    integrationDisplayName: newData.integrationDisplayName,
    lastMessageTime: newData.isReminderTriggered ? newData.lastMessageTime : newData.messageTime,
    lastMessage: {
      ...(oldData ? oldData.lastMessage : {}),
      message: newData.isReminderTriggered ? (newData.lastMessage as MessageTypes) : newData.message,
      id: newData.messageId,
      templateId: null,
      senderId: newData.senderId,
      messageOriginType: newData.messageOriginType,
      messageTime: newData.messageTime,
      ...getCountFromStatus(newData.status),
    },
    isReminderTriggered: newData.isReminderTriggered,
    reminderTime: newData.reminderTime,
  };

  if (!!newData.validUsersCustomerName) {
    const nameFromSocket = newData.validUsersCustomerName.find((item) => item.userId === currentUserId);
    if (nameFromSocket) {
      modifiedData.name = nameFromSocket.name;
    }
  }
  return modifiedData;
};

export default chatRowDataHelper;
